module.exports = {

  title: '中材检测用户中心',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false
}



// WEBPACK FOOTER //
// ./src/settings.js